import { Collapse } from "antd";
import { StarFilled } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { useTranslation } from "../../i18n/LanguageContext";
import "./style.css";

const Organizations = () => {
    const { t } = useTranslation();

    const items = t("org.why").map((item, i) => ({
        key: String(i),
        label: item.label,
        extra: <StarFilled style={{ color: "#FF7B00" }} />,
        children: <p style={{ paddingInlineStart: 24 }}>{item.text}</p>,
    }));

    return (
        <div className="main-content-wrapper">
            <div className="organizationsPage">
                <h2>{t("page.organizations.title")}</h2>
                <p>{t("org.intro")}</p>
                <h3>{t("org.whyTitle")}</h3>
                <Collapse
                    className="collapseAbout"
                    items={items}
                    bordered={false}
                    accordion
                    collapsible={"header"}
                />
                <h3>{t("org.goalTitle")}</h3>
                <p>{t("org.goal")}</p>
                <Link to="/registerOrganization" className="joinBtn">
                    {t("org.cta")}
                </Link>
            </div>
        </div>
    );
};

export default Organizations;
